import type { RouteRecordRaw, RouteLocationNormalized, NavigationGuardNext } from 'vue-router';
import { useQueryClient } from '@tanstack/vue-query';
import { logout as authLogout } from '@/modules/auth/auth';
import { reset as resetAnalytics } from '@/libs/analytics';
import { resetStore as resetVuexStore } from '@/store/resetStore';

export default [
  {
    path: '/logout',
    name: 'logout',
    async beforeEnter(
      _to: RouteLocationNormalized,
      _from: RouteLocationNormalized,
      next: NavigationGuardNext,
    ) {
      // Clear the query cache so the next account doesn't inherit this one's
      // cached org/user/permissions. This also drops the session query, so the
      // destination's guards re-read it fresh. useQueryClient is captured
      // synchronously — the guard has an inject context only until the first await.
      const queryClient = useQueryClient();
      const path = await authLogout();
      resetVuexStore();
      resetAnalytics();
      queryClient.clear();
      next({ path });
    },
    component: () => h('div'),
  },
] satisfies RouteRecordRaw[];
